export const EMAIL_REGEX =
  /^[a-zA-Z\d%+-][\w.'%+-]*(?:'[^\s]*)?@[\w.-]+\.[a-zA-Z]{2,}$/;

export const EMAIL_DOMAIN_REGEX = /^@[\w.-]+\.[a-zA-Z]{2,}$/;

export const NAME_REGEX = /^[a-zA-Z0-9\s'-]+$/;

export const PHONENUMBER_REGEX =
  /^(?:\+?\d+|\(\d+\)|\d+)(?:[ -](?:\+?\d+|\(\d+\)|\d+))*$/;

export const MOBILE_NUMBER_REGEX =
  /^(?:[2378]\d{8}|0[2378]\d{8}|04\d{8}|1300\d{6}|13\d{4}|1800\d{6}|\+61[2378]\d{8}|\+614\d{8})$/;

export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9 ]*$/;
